(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-accessory-modal"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    
    // =============================================
    // 1. SETUP
    // =============================================
    const selectors = {
      triggerContainer: '#bundle-injection-point',
      modal: '#bundle-modal-backdrop',
      modalFooter: '#bundle-modal-footer',
      closeBtn: '#bundle-modal-close',
      triggerBtn: '#bundle-trigger-btn',
      applyBtn: '#bundle-apply-btn',
      thumbnailsContainer: '#bundle-active-thumbnails',
      priceSummaryContainer: '#bundle-price-summary',
      pageBreakdown: '#bundle-breakdown',
      footerBreakdown: '#bundle-footer-breakdown',
      empireForm: 'form[action*="/cart/add"]',
      empireAtcButton: '.product-form--atc-button, [name="add"]', 
      dataBridge: '#bundle-hijack-data',
      totalDisplay: '#bundle-live-total',
      unsavedBar: '#bundle-unsaved-bar',
      unsavedDiscard: '#bundle-unsaved-discard',
      unsavedApply: '#bundle-unsaved-apply',
      errorToast: '#bundle-error-toast',
      errorMessage: '#bundle-error-message',
      errorClose: '#bundle-error-close'
    };

    const bridgeEl = document.querySelector(selectors.dataBridge);
    if (!bridgeEl) return; 
    
    let bundleData;
    try {
      bundleData = JSON.parse(bridgeEl.textContent);
    } catch (e) {
      console.error('Bundle Error: JSON Parse Failed', e);
      return;
    }
    
    // Working state: Set of product IDs currently toggled in modal
    let selectedAccessories = new Set();
    // Applied state: Set of product IDs confirmed and reflected on page
    let appliedAccessories = new Set();
    
    let isInterceptActive = false;
    let lastKnownVariantId = null;

    // Build availability map keyed by product ID
    // A product is available if any of its variants are available
    const inventoryMap = {};
    bundleData.accessories.forEach(acc => {
      inventoryMap[acc.productId] = acc.variants.some(v => v.available !== false);
    });

    // =============================================
    // 2. VARIANT MATCHING
    // =============================================
    
    // Given an accessory product, find the variant that best matches
    // the currently selected main product variant.
    // Matches by checking if accessory variant title appears in main variant title.
    function getMatchingVariant(accProduct) {
      const mainVarInfo = bundleData.mainVariants[lastKnownVariantId];
      const mainTitle = mainVarInfo ? mainVarInfo.title : '';
      
      if (mainTitle) {
        const match = accProduct.variants.find(v =>
          mainTitle.toLowerCase().includes(v.title.toLowerCase()) ||
          v.title.toLowerCase().includes(mainTitle.toLowerCase())
        );
        if (match) return match;
      }
      
      // Fallback: first available variant, or just first variant
      return accProduct.variants.find(v => v.available) || accProduct.variants[0];
    }

    // Update all card prices based on current main variant selection
    function updateCardPrices() {
      document.querySelectorAll('.bundle-card[data-product-id]').forEach(card => {
        const productId = parseInt(card.dataset.productId);
        const accProduct = bundleData.accessories.find(a => a.productId == productId);
        if (!accProduct) return;

        const variant = getMatchingVariant(accProduct);
        if (!variant) return;

        // Update data attribute
        card.dataset.price = variant.price;

        // Update displayed price
        const priceEl = card.querySelector('.bundle-card-price');
        if (priceEl) {
          const unavailableLabel = priceEl.querySelector('.bundle-unavailable-label');
          priceEl.textContent = formatMoney(variant.price);
          priceEl.style.display = variant.price === 0 ? 'none' : '';
          if (!variant.available && unavailableLabel) {
            priceEl.appendChild(unavailableLabel);
          }
        }

        // Update variant label if shown
        const variantEl = card.querySelector('.bundle-card-variant');
        if (variantEl && variant.title !== 'Default Title') {
          variantEl.textContent = variant.title;
        }
      });
    }

    // =============================================
    // 3. DOM INJECTION (Smart Placement)
    // =============================================
    const empireForm = document.querySelector(selectors.empireForm);
    const triggerContainer = document.querySelector(selectors.triggerContainer);
    
    if (empireForm && triggerContainer) {
      const atcButton = empireForm.querySelector(selectors.empireAtcButton);
      if (atcButton) {
        const atcWrapper = atcButton.parentElement; 
        if (atcWrapper) {
          atcWrapper.parentNode.insertBefore(triggerContainer, atcWrapper);
        } else {
          atcButton.parentNode.insertBefore(triggerContainer, atcButton);
        }
        triggerContainer.style.display = 'block';
      }
    }

    // =============================================
    // 4. CORE LOGIC
    // =============================================
    const formatMoney = (cents) => {
      if (isNaN(cents)) cents = 0; 
      const symbol = bundleData.currencySymbol || '$';
      return symbol + (cents / 100).toFixed(2); 
    };

    function getActiveMainVariantPrice() {
      if (!empireForm) return bundleData.mainProductPrice; 
      const input = empireForm.querySelector('[name="id"]');
      if (input) lastKnownVariantId = input.value;
      if (!input || !input.value) return bundleData.mainProductPrice;
      const varInfo = bundleData.mainVariants[input.value];
      if (varInfo !== undefined) return varInfo.price;
      return bundleData.mainProductPrice; 
    }

    function getActiveMainQuantity() {
      if (!empireForm) return 1;
      const input = empireForm.querySelector('[name="quantity"]');
      if (!input || !input.value) return 1;
      return parseInt(input.value) || 1;
    }

    function getAccessoriesTotal(accessorySet) {
      let total = 0;
      accessorySet.forEach(productId => {
        const accProduct = bundleData.accessories.find(a => a.productId == productId);
        if (accProduct) {
          const variant = getMatchingVariant(accProduct);
          if (variant) total += variant.price;
        }
      });
      return total;
    }

    // =============================================
    // 5. UI UPDATE FUNCTIONS
    // =============================================

    function updateModalUI() {
      const mainPrice = getActiveMainVariantPrice();
      const qty = getActiveMainQuantity();
      const mainLineTotal = mainPrice * qty;
      const accTotal = getAccessoriesTotal(selectedAccessories);
      const bundleTotal = mainLineTotal + accTotal;

      // Modal live total
      const modalTotalEl = document.querySelector(selectors.totalDisplay);
      if (modalTotalEl) modalTotalEl.textContent = formatMoney(bundleTotal);

      // Modal footer breakdown
      const footerBreakdown = document.querySelector(selectors.footerBreakdown);
      if (footerBreakdown) {
        if (bundleTotal > 0) {
          const qtyLabel = qty > 1 ? (' × ' + qty) : '';
          footerBreakdown.innerHTML = 
            '<span style="color:#666;">' + bundleData.mainProductTitle + qtyLabel + ': ' + formatMoney(mainLineTotal) + '</span>' +
            ' + <span style="color:#666;">' + selectedAccessories.size + ' accessor' + (selectedAccessories.size === 1 ? 'y' : 'ies') + ': ' + formatMoney(accTotal) + '</span>';
        } else {
          footerBreakdown.innerHTML = '';
        }
      }

      // Hide total display when $0
      const totalDisplay = document.querySelector('.bundle-total-display');
      if (totalDisplay) totalDisplay.style.display = bundleTotal > 0 ? '' : 'none';
      // Show/hide modal footer
      const hasSelections = selectedAccessories.size > 0;
      const modalFooter = document.querySelector(selectors.modalFooter);
      if (modalFooter) modalFooter.style.display = hasSelections ? 'flex' : 'none';
    }

    function updatePageUI() {
      const hasApplied = appliedAccessories.size > 0 && getAccessoriesTotal(appliedAccessories) > 0;

      const summaryContainer = document.querySelector(selectors.priceSummaryContainer);
      if (summaryContainer) summaryContainer.style.display = hasApplied ? 'block' : 'none';

      const pageBreakdown = document.querySelector(selectors.pageBreakdown);
      if (pageBreakdown && hasApplied) {
        const mainPrice = getActiveMainVariantPrice();
        const qty = getActiveMainQuantity();
        const mainLineTotal = mainPrice * qty;
        const accTotal = getAccessoriesTotal(appliedAccessories);
        const bundleTotal = mainLineTotal + accTotal;

        pageBreakdown.innerHTML = '<div class="bundle-total-line"><span>Your Total</span><span>' + formatMoney(bundleTotal) + '</span></div>';
      }
    }

    // =============================================
    // 6. CLOSE/APPLY AMBIGUITY LOGIC
    // =============================================

    function setsAreEqual(a, b) {
      if (a.size !== b.size) return false;
      for (const item of a) {
        if (!b.has(item)) return false;
      }
      return true;
    }

    function hasUnappliedChanges() {
      return !setsAreEqual(selectedAccessories, appliedAccessories);
    }

    function showUnsavedBar() {
      const bar = document.querySelector(selectors.unsavedBar);
      if (bar) bar.style.display = 'flex';
    }

    function hideUnsavedBar() {
      const bar = document.querySelector(selectors.unsavedBar);
      if (bar) bar.style.display = 'none';
    }

    function revertToApplied() {
      selectedAccessories = new Set(appliedAccessories);
      document.querySelectorAll('.bundle-card').forEach(card => {
        const productId = parseInt(card.dataset.productId);
        if (appliedAccessories.has(productId)) {
          card.classList.add('is-selected');
        } else {
          card.classList.remove('is-selected');
        }
      });
      updateModalUI();
    }

    function applySelections() {
      appliedAccessories = new Set(selectedAccessories);
      isInterceptActive = appliedAccessories.size > 0;
      updateThumbnails();
      updatePageUI();
      hideUnsavedBar();
      updateGlobalAccessories();
    }

    function updateGlobalAccessories() {
      window.bundleAppliedAccessories = [];
      appliedAccessories.forEach(function(productId) {
        var accProduct = bundleData.accessories.find(function(a) { return a.productId == productId; });
        if (accProduct) {
          var variant = getMatchingVariant(accProduct);
          window.bundleAppliedAccessories.push({
            title: accProduct.productTitle,
            variantTitle: variant ? variant.title : '',
            price: variant ? variant.price : 0
          });
        }
      });
    }

    function attemptClose() {
      if (hasUnappliedChanges() && getAccessoriesTotal(selectedAccessories) > 0) {
        showUnsavedBar();
        return;
      }
      applySelections();
      closeModal();
    }

    function closeModal() {
      const modal = document.querySelector(selectors.modal);
      if (modal) modal.classList.remove('is-open');
      hideUnsavedBar();
    }

    // =============================================
    // 7. ERROR HANDLING
    // =============================================

    let errorToastTimer = null;

    function showError(message) {
      const toast = document.querySelector(selectors.errorToast);
      const msgEl = document.querySelector(selectors.errorMessage);
      if (!toast || !msgEl) return;
      
      msgEl.textContent = message;
      toast.style.display = 'block';
      toast.classList.add('is-visible');

      clearTimeout(errorToastTimer);
      errorToastTimer = setTimeout(() => { hideError(); }, 8000);
    }

    function hideError() {
      const toast = document.querySelector(selectors.errorToast);
      if (toast) {
        toast.classList.remove('is-visible');
        toast.style.display = 'none';
      }
      clearTimeout(errorToastTimer);
    }

    const errorCloseBtn = document.querySelector(selectors.errorClose);
    if (errorCloseBtn) {
      errorCloseBtn.addEventListener('click', hideError);
    }

    // =============================================
    // 8. VARIANT POLLER
    // =============================================
    // Polls for main variant changes and updates accessory prices to match
    setInterval(() => {
      if (!empireForm) return;
      const input = empireForm.querySelector('[name="id"]');
      if (input && input.value !== lastKnownVariantId) {
        lastKnownVariantId = input.value;
        updateCardPrices();
        updateModalUI();
        updatePageUI();
      }
    }, 500);

    // Initialize lastKnownVariantId on load
    if (empireForm) {
      const input = empireForm.querySelector('[name="id"]');
      if (input) lastKnownVariantId = input.value;
    }

    // =============================================
    // 9. EVENT LISTENERS
    // =============================================
    const modal = document.querySelector(selectors.modal);
    
    // Open modal
    document.querySelector(selectors.triggerBtn).addEventListener('click', () => {
      selectedAccessories = new Set(appliedAccessories);
      document.querySelectorAll('.bundle-card').forEach(card => {
        const productId = parseInt(card.dataset.productId);
        if (selectedAccessories.has(productId)) {
          card.classList.add('is-selected');
        } else {
          card.classList.remove('is-selected');
        }
      });
      updateCardPrices();
      hideUnsavedBar();
      updateModalUI();
      modal.classList.add('is-open');
    });
    
    // Close button
    document.querySelector(selectors.closeBtn).addEventListener('click', () => {
      attemptClose();
    });
    
    // Backdrop click
    modal.addEventListener('click', (e) => {
      if (e.target === modal) attemptClose();
    });

    // Unsaved bar — Discard
    document.querySelector(selectors.unsavedDiscard).addEventListener('click', () => {
      revertToApplied();
      closeModal();
    });

    // Unsaved bar — Apply
    document.querySelector(selectors.unsavedApply).addEventListener('click', () => {
      applySelections();
      closeModal();
    });

    // Title click — toggle card
    document.querySelectorAll('.bundle-card-title--clickable').forEach(title => {
      title.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const card = title.closest('.bundle-card');
        if (!card) return;
        const productId = parseInt(card.dataset.productId);
        if (inventoryMap[productId] === false) return;
        if (selectedAccessories.has(productId)) {
          selectedAccessories.delete(productId);
          card.classList.remove('is-selected');
        } else {
          selectedAccessories.add(productId);
          card.classList.add('is-selected');
        }
        hideUnsavedBar();
        updateModalUI();
      });
    });

    // Card add/remove buttons
    document.querySelectorAll('.bundle-add-btn:not(.is-disabled)').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault(); 
        e.stopPropagation(); 
        
        const card = btn.closest('.bundle-card');
        const productId = parseInt(card.dataset.productId);

        if (inventoryMap[productId] === false) return;
        
        if (selectedAccessories.has(productId)) {
          selectedAccessories.delete(productId);
          card.classList.remove('is-selected');
        } else {
          selectedAccessories.add(productId);
          card.classList.add('is-selected');
        }
        hideUnsavedBar();
        updateModalUI();
      });
    });

    // Apply button
    document.querySelector(selectors.applyBtn).addEventListener('click', () => {
      applySelections();
      closeModal();
    });

    // =============================================
    // 10. THUMBNAILS
    // =============================================
    function updateThumbnails() {
      const container = document.querySelector(selectors.thumbnailsContainer);
      if (!container) return;
      container.innerHTML = '';
      
      appliedAccessories.forEach(productId => {
        const item = bundleData.accessories.find(a => a.productId == productId);
        if (!item) return;

        const variant = getMatchingVariant(item);
        const displayPrice = variant ? variant.price : 0;
        const displayImage = (variant && variant.image) ? variant.image : item.productImage;

        const thumb = document.createElement('div');
        thumb.className = 'bundle-thumb';
        
        thumb.innerHTML = 
          '<a href="' + item.productUrl + '" target="_blank" class="bundle-thumb-link" title="View Product">' +
            '<img src="' + displayImage + '">' +
            '<span>' + item.productTitle + '</span>' +
          '</a>' +
          (displayPrice > 0 ? '<span class="bundle-thumb-price">' + formatMoney(displayPrice) + '</span>' : '') +
          '<span class="bundle-thumb-remove" data-product-id="' + productId + '">✕</span>';
        
        thumb.querySelector('.bundle-thumb-remove').addEventListener('click', (e) => {
          e.stopPropagation();
          appliedAccessories.delete(productId);
          selectedAccessories.delete(productId);
          const card = document.querySelector('.bundle-card[data-product-id="' + productId + '"]');
          if (card) card.classList.remove('is-selected');
          
          isInterceptActive = appliedAccessories.size > 0;
          updatePageUI();
          updateThumbnails();
          updateGlobalAccessories();
        });

        container.appendChild(thumb);
      });
    }

    // =============================================
    // 11. INFO TOOLTIP — Mobile Tap Support
    // =============================================
    document.querySelectorAll('.bundle-info-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const wrap = btn.closest('.bundle-info-wrap');
        const isOpen = wrap.classList.contains('is-open');
        document.querySelectorAll('.bundle-info-wrap.is-open').forEach(w => w.classList.remove('is-open'));
        if (!isOpen) wrap.classList.add('is-open');
      });
    });
    document.addEventListener('click', () => {
      document.querySelectorAll('.bundle-info-wrap.is-open').forEach(w => w.classList.remove('is-open'));
    });

    // =============================================
    // 12. CART INTERCEPT (with Smart Error Handling)
    // =============================================
    if (empireForm) {
      const atcBtn = empireForm.querySelector(selectors.empireAtcButton);
      if (atcBtn) {
        atcBtn.addEventListener('click', async (e) => {
          if (!isInterceptActive) return; 
          
          e.preventDefault();
          e.stopPropagation();
          
          const originalText = atcBtn.innerText;
          atcBtn.innerText = 'Adding Bundle...'; 
          atcBtn.disabled = true;

          const idInput = empireForm.querySelector('[name="id"]');
          const mainVariantId = idInput ? idInput.value : bundleData.mainProductId;
          const mainQuantity = getActiveMainQuantity();

          const items = [];
          items.push({ id: parseInt(mainVariantId), quantity: mainQuantity });
          
          // For each selected accessory product, add the variant that matches current main selection
          appliedAccessories.forEach(productId => {
            const accProduct = bundleData.accessories.find(a => a.productId == productId);
            if (accProduct) {
              const variant = getMatchingVariant(accProduct);
              if (variant) {
                items.push({ id: variant.id, quantity: 1 });
              }
            }
          });

          try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: items })
            });

            if (response.ok) {
              window.location.href = '/cart';
            } else {
              console.warn('Bundle batch add failed. Attempting individual identification...');
              await handleBatchFailure(items, atcBtn, originalText);
            }
          } catch (err) {
            console.error('Network Error:', err);
            showError('Something went wrong adding your bundle. Please check your connection and try again.');
            atcBtn.disabled = false;
            atcBtn.innerText = originalText;
          }
        });
      }
    }

    async function handleBatchFailure(items, atcBtn, originalText) {
      const failedItems = [];
      const succeededItems = [];

      for (const item of items) {
        try {
          const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [item] })
          });
          if (res.ok) {
            succeededItems.push(item);
          } else {
            const accMatch = bundleData.accessories.find(a => a.variants.some(v => v.id == item.id));
            const failName = accMatch ? accMatch.productTitle : bundleData.mainProductTitle;
            failedItems.push(failName);
          }
        } catch (err) {
          const accMatch = bundleData.accessories.find(a => a.variants.some(v => v.id == item.id));
          const failName = accMatch ? accMatch.productTitle : bundleData.mainProductTitle;
          failedItems.push(failName);
        }
      }

      atcBtn.disabled = false;
      atcBtn.innerText = originalText;

      if (failedItems.length === 0 && succeededItems.length > 0) {
        window.location.href = '/cart';
      } else if (succeededItems.length > 0 && failedItems.length > 0) {
        const failList = failedItems.join(', ');
        showError('Some items were added to your cart, but the following could not be added (likely out of stock): ' + failList + '. You can review your cart or try again.');
      } else {
        showError('Unable to add items to your cart. Please try again or call (888) 883-7568 for assistance.');
      }
    }

  });

  } catch(e) { console.error(e); }
})();
})();
